import { QUERY_KEY_PREFIXES } from 'dpl/shared/fetching/utils/constants';

export function contactEditDefinition(
  breederProfileId,
  contactType,
  dogId,
  breedId,
  litterId
) {
  const params = { dog_id: dogId };
  if (breedId) params.breed_id = breedId;
  if (litterId) params.litter_id = litterId;
  return {
    prefix: QUERY_KEY_PREFIXES.CONTACT_EDIT,
    params,
    url: `/api/breeder_profiles/${breederProfileId}/contacts/${contactType}/edit.json`,
    enabled: Boolean(breederProfileId) && Boolean(contactType)
  };
}

export function sendVerificationCodeMutationDefinition(verification) {
  return {
    url: `/api/users/verifications/send_code.json`,
    method: 'POST',
    params: { verification }
  };
}

// Multi-apply quick apply: creates one child BuyerApplication under
// `buyerApplicationId` for the suggested breeder named in the request body.
export function multiApplyQuickApplyMutationDefinition(buyerApplicationId) {
  return {
    url: `/api/buyer_applications/${buyerApplicationId}/multi_apply_applications.json`,
    method: 'POST'
  };
}

export function enhancedConversionDataDefinition() {
  return {
    url: `/api/me/enhanced_conversion_data.json`,
    enabled: false
  };
}
